
import { defineComponent } from '@nuxtjs/composition-api';
import { mapActions } from 'vuex';
import GongAnimationModal from '@/components/partials/war-room/GongAnimation/GongAnimationModal.vue';
import WarRoomConfirmRemovePost from '@/components/partials/war-room/WarRoomConfirmRemovePost.vue';
import WarRoomPostList from '@/components/partials/war-room/WarRoomPostList.vue';
import WarRoomTopicsListModal from '@/components/partials/war-room/WarRoomTopicsListModal.vue';
import warRoomFetchPostsMixin from '@/components/partials/war-room/warRoomFetchPostsMixin';
import { makeCanonicalUrlForPagination } from '@/components/partials/war-room/utils';
import { WAR_ROOM_POSTS_TAB_MYFEED_PAGE } from '@/constants';
import { TITLE_FEED, DESCRIPTION_FEED } from '@/constants/defaultMeta';
import { feedTabNames } from '@/components/partials/war-room/constants';
import WarRoomMarkPostsAsReadMutation from '~/apollo/mutations/WarRoomMarkPostsAsRead.mutation';

export default defineComponent({
  name: 'WarRoomPostsPage',
  components: {
    GongAnimationModal,
    WarRoomConfirmRemovePost,
    WarRoomPostList,
    WarRoomTopicsListModal,
  },
  mixins: [warRoomFetchPostsMixin],
  beforeRouteLeave(_to, from, next) {
    if (from.params.tab === WAR_ROOM_POSTS_TAB_MYFEED_PAGE.params.tab) {
      this.toggleUnreadPostsLabel(false);
      this.updateWarRoomLastVisit();
    }

    next();
  },
  beforeRouteUpdate(to, from, next) {
    if (
      to.params.tab !== WAR_ROOM_POSTS_TAB_MYFEED_PAGE.params.tab &&
      from.params.tab === WAR_ROOM_POSTS_TAB_MYFEED_PAGE.params.tab
    ) {
      this.toggleUnreadPostsLabel(false);
      this.updateWarRoomLastVisit();
    }

    next();
  },
  validate(ctx) {
    const tabName = ctx.route.params.tab;
    return Boolean(tabName && feedTabNames[tabName]);
  },
  head() {
    const tabName = feedTabNames[this.$route.params.tab] || '';
    const page = this.$route.query?.page;
    const title = `${tabName} | ${TITLE_FEED}${page ? ` | Page ${page}` : ''}`;
    const description = `${DESCRIPTION_FEED}${page ? ` | Page ${page}` : ''}`;

    return this.$seo({
      title,
      description,
      canonical: makeCanonicalUrlForPagination({ path: this.$route.path, query: this.$route.query }),
    });
  },
  mounted() {
    if (this.$route.params.tab === WAR_ROOM_POSTS_TAB_MYFEED_PAGE.params.tab) {
      this.$3rdParty.loadImmediately('userleap');
    }
  },
  methods: {
    ...mapActions('warRoom', ['toggleUnreadPostsLabel']),
    async updateWarRoomLastVisit() {
      try {
        if (this.$auth.loggedIn && process.client) {
          await this.$apollo.mutate({
            mutation: WarRoomMarkPostsAsReadMutation,
            variables: { input: {} },
          });
        }
      } catch (e) {
        this.$notice.error(e);
        this.$sentryUtils.error(e);
      }
    },
  },
});
